import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Typography,
  message,
  Form,
  Input,
  Select,
  DatePicker,
  Row,
  Col,
  InputNumber,
  Button,
} from "antd";
import { platformApi } from "../../../../api";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";

const { Option } = Select;

const formatAddress = (address) => {
  if (!address) return "";
  return [
    address.line1,
    address.line2,
    address.line3,
    address.locality,
    address.district?.name,
    address.state?.name,
    address.country?.name,
    address.pincode,
  ]
    .map((part) => (part == null ? "" : String(part).trim()))
    .filter(Boolean)
    .join(", ");
};

function VehicleSaleModal(props) {
  const { open, close, dataSource, form, saleId, engineNo, isEdit } = props;

  const {
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    resetFields,

  } = form;

  const [data, setData] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [modeType, setModeType] = useState(null);
  const [isHypothecation, setIsHypothecation] = useState(dataSource?.hypothecation);
  const [chellanOptions, setChellanOptions] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  const [colorObj, setColorObj] = useState(null);
  const [salesId, setSalesId] = useState("");

  useEffect(() => {
    if (dataSource && !isEdit) {
      setModeType(dataSource.loan?.financer ? "finance" : "cash");
      setIsHypothecation(dataSource.hypothecation);

      // Determine hypothecation value from booking loan data
      const bookingHypothecation = dataSource.loan?.hypothecation;
      const hypothecationValue =
        bookingHypothecation === true || bookingHypothecation === "Yes" ? "Yes" : "No";

      setFieldsValue({
        invoiceNo: invoiceNumber,
        invoiceDate: moment(),
        challanNo: dataSource?.bookingId,
        party: `${dataSource?.customer?.name} - ${dataSource?.customer?.contacts?.[0]?.phone}`,
        address: formatAddress(dataSource?.customer?.address),
        vehicleModel: dataSource.vehicle?.modelName,
        chassisNumber: dataSource.chassisNumber,
        engineNumber: engineNo,
        color: dataSource.color,
        modeType: dataSource.price?.paymentMode,
        financier: dataSource.loan?.financer?.name,
        hypothecation: hypothecationValue,
        remarks: dataSource.remarks || "",
        net: dataSource?.price?.showroomPrice || 0,
      });

      if (!invoiceNumber && dataSource.branch?.id) {
        generateId(dataSource.branch.id);
      }
      if (dataSource.vehicle?.id) {
        getVehicleDetails(dataSource.vehicle.id).then((vdata) => {
          const igst = vdata?.hsn?.igst || 0;
          const cess = vdata?.hsn?.cess || 0;
          const prices = vdata.price || [];
          const selectedColorId = dataSource.color.color;

          // getLatestVehiclePrice(dataSource.vehicle.id).then((latestPrice) => {
          //   let showroomPrice = null;
          //   let tcsAmount = null;

          // if (latestPrice) {
          //   showroomPrice = latestPrice[0].showroomPrice;
          //   tcsAmount = latestPrice[0].tcs;
          // } else {
          // for (const priceObj of prices) {
          //   const match = priceObj.colors.find(
          //     (c) => c.colorName === selectedColorId
          //   );
          //   if (match) {
          //     showroomPrice = priceObj.showroomPrice;
          //     tcsAmount = priceObj.tcs;
          //     break;
          //   }
          // }
          // }

          // if (showroomPrice !== null) {
          const price = dataSource?.price?.showroomPrice / (1 + igst / 100);
          const gst = dataSource?.price?.showroomPrice - price;

          setFieldsValue({
            price: price,
            gst: gst,
            cess: cess,
            // tcsAmount: tcsAmount,
          });
          // }
        });
        // });
      }
      setColorObj(dataSource.color);
    } else if (isEdit && dataSource) {
      setData(dataSource);

      let colorData = dataSource.color;
      if (typeof colorData === "string") {
        try {
          colorData = JSON.parse(colorData);
        } catch (e) {
          colorData = { color: colorData };
        }
      }
      setModeType(dataSource.modeType);
      setIsHypothecation(dataSource.hypothecation);
      setColorObj(colorData);
      setFieldsValue({
        invoiceNo: dataSource.invoiceNo,
        invoiceDate: moment(dataSource.date),
        challanNo: dataSource.saleRegister?.bookingId,
        party: `${dataSource.party?.name} - ${dataSource.party?.contacts?.[0]?.phone}`,
        address: dataSource.address,
        vehicleModel: dataSource.vehicleModel,
        chassisNumber: dataSource.chassisNumber,
        engineNumber: dataSource.engineNumber,
        color: colorData,
        modeType: dataSource.modeType,
        financier: dataSource.financier,
        hypothecation: dataSource.hypothecation === true ? "Yes" : "No",
        remarks: dataSource.remarks || "",
        price: dataSource.price,
        tcsAmount: dataSource.tcsAmount,
        gst: dataSource.gst,
        net: dataSource.net,
      });
    }
  }, [dataSource, invoiceNumber]);

  useEffect(() => {
    platformApi
      .post(`api/saleRegister/getAll`, { searchString })
      .then((res) => {
        setChellanOptions(res.data.data.saleRegisters);
      })
      .catch((err) => {
        console.error("Error getting options");
      });
  }, [searchString, dataSource]);

  useEffect(() => {
    // console.log("financier change",getFieldValue("financier"));
  }, [getFieldDecorator("financier")])

  const getSaleDetails = (bookingId) => {
    const encodedId = encodeURIComponent(bookingId);

    platformApi.get(`/api/saleRegister/getOne/${encodedId}`).then((res) => {
      setSalesId(res.data?.data?.id);
      const saleData = res.data.data.saleData;
      generateId(saleData?.branch?.id);
      setData(saleData);
      setFieldsValue({
        invoiceNo: invoiceNumber,
        invoiceDate: moment(),
        challanNo: res.data.data?.bookingId || saleData.bookingId,
        party: `${saleData?.customer?.name} - ${saleData?.customer?.contacts?.[0]?.phone}`,
        address: formatAddress(saleData?.customer?.address),
        vehicleModel: saleData.vehicle?.modelName,
        chassisNumber: res.data.data?.chassisNumber,
        engineNumber: res.data.data?.engineNo,
        color: saleData.color,
        modeType: saleData.loan?.financer ? "finance" : "cash",
        financier: saleData.loan?.financer?.name,
        remarks: saleData.remarks || "",
      });
      setColorObj(saleData.color);
      if (saleData.vehicle?.id) {
        getVehicleDetails(saleData.vehicle.id).then((vdata) => {
          const igst = vdata?.hsn?.igst || 0;
          const cess = vdata?.hsn?.cess || 0;
          const prices = vdata.price || [];
          const selectedColorId = saleData.color.id;
          let showroomPrice = null;
          let tcsAmount = null;
          for (const priceObj of prices) {
            const match = priceObj.colors.find(
              (c) => c.colorId === selectedColorId
            );
            if (match) {
              showroomPrice = priceObj.showroomPrice;
              tcsAmount = priceObj.tcs;
              break;
            }
          }
          if (showroomPrice !== null) {
            const price = showroomPrice / (1 + igst / 100);
            const gst = showroomPrice - price;
            setFieldsValue({
              price: price,
              gst: gst,
              cess: cess,
              tcsAmount: tcsAmount,
            });
          }
        });
      }
    });
  };

  const generateId = (branch) => {
    platformApi
      .post(`/api/idGenerate/saleInvoice`, { branch: branch })
      .then((res) => {
        setInvoiceNumber(res.data.response.data);
        setFieldsValue({ invoiceNo: res.data.response.data });
      })
      .catch((err) => {
        message.error("error in generate id");
        console.error("id generation error:", err);
      });
  };

  const getVehicleDetails = (vehicleId) => {
    return platformApi.get(`/api/vehicleMaster/${vehicleId}`).then((res) => {
      return res.data.response.data;
    });
  };

  const getLatestVehiclePrice = (vehicleId) => {
    try {
      return platformApi.get(`/api/vehiclePrice/latest/${vehicleId}`).then((res) => {
        return res.data?.response?.data || null;
      })

    } catch (err) {
      console.error("Error fetching latest vehicle price:", err);
      return null;
    }
  };

  const handleChallanChange = (recordId) => {
    getSaleDetails(recordId);
  };

  const handleSearch = (value) => {
    setSearchString(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        if (isEdit) {
          // Only update remarks
          platformApi
            .put(`api/saleInvoice/${dataSource.id}`, {
              remarks: values.remarks,
            })
            .then((res) => {
              setLoading(false);
              handleClose();
            })
            .catch((err) => {
              setLoading(false);
              message.error("Error updating remarks");
            });
        } else {
          // Use latest data (from 'data' if set, else 'dataSource')
          const currentData = data || dataSource;
          const payload = {
            date: values.invoiceDate
              ? values.invoiceDate.format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
            invoiceNo: values.invoiceNo,
            saleRegister: saleId || salesId,
            party: currentData?.customer?.id,
            address: values.address,
            vehicleModel: values.vehicleModel,
            chassisNumber: values.chassisNumber,
            engineNumber: values.engineNumber,
            color: JSON.stringify(colorObj),
            mfgMonthYear: currentData?.mfgMonthYear,
            remarks: values.remarks,
            price: values.price,
            gst: values.gst,
            cess: values.cess,
            tcsAmount: values.tcsAmount,
            net: values.net,
            modeType: values.modeType,
            financier: currentData?.loan?.financer?.name,
            branch: currentData?.branch?.id,
            hypothecation: values.hypothecation === "Yes",
          };
          platformApi
            .post(`api/saleInvoice`, payload)
            .then((res) => {
              setLoading(false);
              handleClose();
            })
            .catch((err) => {
              setLoading(false);
              message.error("Error adding invoice");
            });
        }
      }
    });
  };

  const handleClose = () => {
    resetFields();
    setData(null);
    setInvoiceNumber(null);
    close();
  };

  return (
    <Modal
      width="75%"
      title="Vehicle Sale Invoice"
      visible={open}
      okText={"Save"}
      onOk={handleSubmit}
      onCancel={handleClose}
      confirmLoading={loading}
    >
      <Form layout="vertical" onSubmit={handleSubmit} ref={formRef}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Invoice Number">
              {getFieldDecorator("invoiceNo")(<Input disabled />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Invoice Date">
              {getFieldDecorator("invoiceDate", {
                rules: [{ required: true }],
                initialValue: moment(),
              })(
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  disabled
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Challan No">
              {getFieldDecorator("challanNo", {
                rules: [{ required: true }],
              })(
                <Select
                  showSearch
                  disabled={!!dataSource}
                  placeholder="Select Challan"
                  filterOption={false}
                  onSearch={handleSearch}
                  onChange={handleChallanChange}
                  notFoundContent={null}
                >
                  {chellanOptions?.map((opt) => (
                    <Option key={opt.id} value={opt.id}>
                      {opt.bookingId}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Party">
              {getFieldDecorator("party")(<Input disabled />)}
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item label="Address">
              {getFieldDecorator("address")(<Input disabled />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Vehicle Model">
              {getFieldDecorator("vehicleModel")(<Input disabled />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Chassis Number">
              {getFieldDecorator("chassisNumber")(<Input disabled />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Engine Number">
              {getFieldDecorator("engineNumber")(<Input disabled />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Payment Type">
              {getFieldDecorator("modeType")(
                <Select disabled>
                  <Option value="cash">Cash</Option>
                  <Option value="finance">Finance</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Hypothecation">
              {getFieldDecorator("hypothecation", {
                rules: [{ required: true, message: "Please select Hypothecation" }],
                initialValue: "No",
              })(
                <Select disabled>
                  <Option value="Yes">Yes</Option>
                  <Option value="No">No</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Row gutter={24}>
            {isHypothecation && (
              <Col span={8}>
                <Form.Item label="Financier">
                  {getFieldDecorator("financier")(<Input disabled />)}
                </Form.Item>
              </Col>
            )}
            <Col span={6}>
              <Form.Item label="Price">
                {getFieldDecorator("price", {
                  rules: [{ required: true }],
                })(
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    disabled
                    formatter={(value) =>
                      value !== undefined ? Number(value).toFixed(2) : ""
                    }
                    parser={(value) => (value ? parseFloat(value) : "")}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Row>
        <Col span={8}>
          <Form.Item label="Color">
            {colorObj && colorObj.url ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={colorObj.url}
                  alt={colorObj.color || "Color"}
                  style={{
                    width: 140,
                    height: 120,
                    marginRight: 8,
                    borderRadius: 4,
                    border: "1px solid #eee",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/140x120?text=No+Image";
                  }}
                />
                <span>
                  {colorObj && colorObj.color
                    ? colorObj.color
                    : typeof dataSource.color === "string"
                      ? dataSource.color
                      : ""}
                </span>
              </div>
            ) : (
              <span>
                {typeof dataSource?.color === "string"
                  ? dataSource.color
                  : dataSource?.color?.color || ""}
              </span>
            )}
          </Form.Item>
        </Col>

        <Row gutter={24}>
          <Col span={6}>
            <Form.Item label="TCS Amount">
              {getFieldDecorator("tcsAmount")(
                <InputNumber style={{ width: "100%" }} disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Cess">
              {getFieldDecorator("cess")(
                <InputNumber style={{ width: "100%" }} disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="GST">
              {getFieldDecorator("gst")(
                <InputNumber
                  style={{ width: "100%" }}
                  disabled
                  formatter={(value) =>
                    value !== undefined ? Number(value).toFixed(2) : ""
                  }
                  parser={(value) => (value ? parseFloat(value) : "")}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Net Amount">
              {getFieldDecorator("net", {
                rules: [{ required: true }],
              })(
                <InputNumber
                  style={{ width: "100%" }}
                  disabled
                  formatter={(value) =>
                    value !== undefined ? Number(value).toFixed(2) : ""
                  }
                  parser={(value) => (value ? parseFloat(value) : "")}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={16}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Form.Item label="Remarks" style={{ flex: 1, marginBottom: 0 }}>
                {getFieldDecorator("remarks", {
                  rules: [
                    {
                      pattern: /^[a-zA-Z0-9\s]*$/,
                      message: "Special characters are not allowed in Remarks",
                    },
                  ],
                })(<Input.TextArea rows={3} />)}
              </Form.Item>
              {isEdit && dataSource?.pdf && (
                <div style={{ marginLeft: 26, textAlign: "right" }}>
                  <div style={{ fontSize: 13, marginBottom: 4 }}>
                    Download Invoice PDF
                  </div>
                  <Button
                    type="default"
                    icon={<DownloadOutlined />}
                    href={dataSource.pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click to download
                  </Button>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default Form.create()(VehicleSaleModal);